export default __webpack_public_path__ + "static/media/virtual-bg19.6abcca87.png";